<template>
  <div>
    <section class="hero is-small is-light">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">Milchliste</h1>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <div class="level">
          <div class="level-left">
            <!-- dummy -->
          </div>
          <div class="level-right">
            <p class="level-item">
              <button v-if="isAdmin" class="button is-primary" @click="edit()">Neuer Eintrag</button>
            </p>
          </div>
        </div>
        <b-table :data="milklistData || []" :loading="isLoading" mobile-cards>
          <template slot-scope="props">
            <b-table-column field="month" label="Monat">{{ props.row.month | localMonthString }}</b-table-column>

            <b-table-column field="nickname" label="Nickname">{{ props.row.nickname }}</b-table-column>

            <b-table-column field="updatedAt" label="Letzte Änderung" centered>
              <span class>{{ props.row.updatedAt | localTime }}</span>
            </b-table-column>

            <b-table-column v-if="isAdmin" custom-key="actions" label="Aktion">
              <button class="button is-small is-light" @click="edit(props.row.nickname)">
                <b-icon pack="fas" icon="edit" size="is-small"></b-icon>
              </button>
            </b-table-column>
          </template>

          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon pack="far" icon="frown" size="is-large"></b-icon>
                </p>
                <p>Keine Einträge</p>
              </div>
            </section>
          </template>
        </b-table>
      </div>
    </section>
  </div>
</template>

<script>
import { Auth, Hub } from "aws-amplify";
import Store from "../store";
import EditScheduleForm from "../components/EditScheduleForm.vue";
import moment from "moment";
import userHelper from "../components/user-helper";

export default {
  name: "dashboard",
  components: {
    EditScheduleForm
  },
  data() {
    return {
      isLoading: false
    };
  },
  filters: {
    localMonthString: function(value) {
      return moment(value, "MM").format("MMMM");
    },
    localTime: function (value) {
          const d = moment(parseInt(value));
          return d.format('DD.MM.YYYY HH:mm:ss');
      }
  },
  computed: {
    user() {
      return Store.state.user;
    },
    isAdmin() {
      return userHelper.isAdmin(this.user);
    },
    tableData() {
      return Store.state.coffees;
    },
    milklistData() {
      return Store.state.coffees.reduce((acc, cur) => {
        if (cur.milkSchedule) {
          return acc.concat(
            cur.milkSchedule.map(m => {
              return { nickname: cur.nickname, month: m, updatedAt: cur.updatedAt };
            })
          );
        }
        return acc;
      }, []).sort( (a,b) => ( a.month - b.month));
    }
  },
  methods: {
    edit(nickname) {
      let data = null;
      if (nickname) {
        data = Store.state.coffees.find(c => c.nickname === nickname);
      }

      this.$modal.open({
        parent: this,
        component: EditScheduleForm,
        hasModalCard: true,
        props: { ...data, formMode: nickname ? "edit" : "create" }
      });
    }
  },
  async mounted() {
    this.isLoading = true;
    try {
      await Store.dispatch("fetchCoffees");

      console.log(this.milklistData);
    } catch (err) {
      console.log(err);
    }
    this.isLoading = false;
  }
};
</script>

